import { sortBy } from 'lodash-es';
import About from '../portal/item/LandingPageTabs/aboutContent/AboutContent';
import AppBar from '../portal/nav/AppBar';
import AppstoreLinksWidget from './components/AppstoreLinksWidget';
import AssetWidget from '../portal/asset/AssetWidget';
import Breadcrumbs from '../portal/nav/Breadcrumbs';
import CategoryNav from '../portal/nav/CategoryNav';
import Checkout from '../portal/checkout/Checkout';
import Class from '../portal/class/Class';
import Confirm from '../portal/checkout/Confirm';
import CopyrightBarWidget from '../portal/nav/CopyrightBarWidget';
import CourseBar from '../portal/class/courseBar/CourseBar';
import CourseDetails from '../portal/course/Tab/Tab';
import CourseSummary from '../portal/course/courseSummary/CourseSummary';
import CourseTabs from '../portal/course/CourseTabsWidget';
import DiscussionGroupWidget from '../portal/discussionGroup/DiscussionGroupWidget';
import Divider from '../portal/nav/Divider';
import DocumentWidget from '../portal/document/DocumentWidget';
import FAQs from '../portal/item/LandingPageTabs/faqContent/FAQContent';
import FeaturedCard from '../portal/course/featured/FeaturedCard';
import FooterBar from '../portal/nav/FooterBar';
import HeaderWidget from './components/HeaderWidget';
import HeaderWithPagination from '../portal/class/headerWithPagination/HeaderWithPagination';
import HtmlWidget from './components/HtmlWidget';
import InfoTabs from '../portal/class/lessonPanel/InfoTabs';
import InstructorDetail from '../portal/Instructors/InstructorDetail';
import Instructors from '../portal/item/LandingPageTabs/instructorsContent/InstructorsContent';
import ItemCarousel from '../portal/item/ItemCarousel';
import ItemList from '../portal/item/ItemList';
import KickerGridWidget from '../portal/kicker/KickerGridWidget';
import LeadWidget from './components/LeadWidget';
import LearningBoardWidget from '../portal/myAccount/LearningBoardWidget';
import LessonCarousel from '../portal/item/LessonCarousel';
import LessonPanel from '../portal/class/lessonPanel/LessonPanel';
import LinksWidget from './components/LinksWidget';
import MeetingCarousel from '../portal/meeting/MeetingCarousel';
import MeetingDeliveryWidget from '../portal/meeting/MeetingDeliveryWidget';
import MeetingSummaryWidget from '../portal/meeting/MeetingSummaryWidget';
import Member from '../portal/myAccount/Member';
import Membership from '../portal/myAccount/Membership';
import MeetNowWidget from '../portal/meeting/MeetNowWidget';
import Microcast from '../portal/microcast/Microcast';
import MyAccount from '../portal/myAccount/MyAccount';
import MyLearnings from '../portal/myLearnings/MyLearnings';
import MyDocuments from '../portal/document/MyDocuments';
import MyMeetings from '../portal/meeting/MyMeetings';
import Notes from '../portal/class/notes/Notes';
import KickerWidget from '../portal/kicker/KickerWidget';
import ProgramSummary from '../portal/program/programSummary/ProgramSummary';
import ProgramTabs from '../portal/program/ProgramTabsWidget';
import PurchaseMembership from '../portal/purchaseMembership/PurchaseMembership';
import QuestionnaireWidget from '../portal/questionnaire/QuestionnaireWidget';
import RecommendedCourses from '../portal/class/recommendedCourses/RecommendedCourses';
import Resources from '../portal/item/LandingPageTabs/resourceContent/Resources';
import Reviews from '../portal/item/LandingPageTabs/reviewsContent/ReviewsContent';
import RichTextWidget from './components/RichTextWidget';
import SearchFilterPanel from '../portal/item/SearchFilterPanel/SearchFilterPanel';
import SearchPage from '../portal/search/SearchPage';
import SectionsPanel from '../portal/class/sectionsPanel/SectionsPanel';
import SocialLinksWidget from './components/SocialLinksWidget';
import SubCategoryNav from '../portal/item/subCategoryNav/SubCategoryNav';
import Syllabus from '../portal/item/LandingPageTabs/syllabusContent/SyllabusContent';
import TopBar from '../portal/nav/TopBar';
import TypeformWidget from './components/TypeformWidget';
import VideoWidget from './components/VideoWidget';
import ConversationWidget from '../portal/clientAi/ConversationWidget';
import VirtualCoachFooterWidget from '../portal/clientAi/CoachFooterWidget';
import VirtualCoachFloatingWidget from '../portal/clientAi/CoachFloatingWidget';
import EmbeddedConversationWidget from '../portal/clientAi/EmbeddedConversationWidget';
import SearchWidget from '../portal/clientAi/SearchWidget';
import HubAppBar from '../hub/nav/HubAppBar';
import HubCategoryNav from '../hub/nav/HubCategoryNav';
import HubToolbar from '../hub/nav/HubToolbar';
// eslint-disable-next-line import/no-cycle
// const Class = loadable(() => import('../portal/class/Class'));
// const SearchPage = loadable(() => import('../portal/search/SearchPage'));
export const KeysToComponentMap = {
    About,
    AppBar,
    AppstoreLinksWidget,
    Breadcrumbs,
    CategoryNav,
    Checkout,
    Class,
    Confirm,
    CopyrightBarWidget,
    CourseBar,
    CourseDetails,
    CourseSummary,
    DiscussionGroupWidget,
    DocumentWidget,
    AssetWidget,
    FAQs,
    FeaturedCard,
    FooterBar,
    HeaderWithPagination,
    RichTextWidget,
    HeaderWidget,
    VideoWidget,
    LinksWidget,
    Divider,
    HtmlWidget,
    HubAppBar,
    HubCategoryNav,
    HubToolbar,
    InfoTabs,
    InstructorDetail,
    Instructors,
    ItemList,
    ItemCarousel,
    KickerGridWidget,
    LearningBoardWidget,
    LessonCarousel,
    LessonPanel,
    MeetingCarousel,
    MeetingDeliveryWidget,
    MeetingSummary: MeetingSummaryWidget,
    MeetNowWidget,
    Member,
    Membership,
    Microcast,
    MyAccount,
    MyDocuments,
    MyLearnings,
    MyMeetings,
    Notes,
    QuestionnaireWidget,
    RecommendedCourses,
    Resources,
    Reviews,
    SearchFilterPanel,
    SectionsPanel,
    SubCategoryNav,
    Syllabus,
    TopBar,
    TypeformWidget,
    PurchaseMembership,
    ProgramSummary,
    ProgramTabs,
    SearchPage,
    SocialLinksWidget,
    KickerWidget,
    LeadWidget,
    CourseTabs,
    ConversationWidget,
    EmbeddedConversationWidget,
    VirtualCoachFooterWidget,
    VirtualCoachFloatingWidget,
    SearchWidget,
};
export const registerComponent = (name, component) => {
    // console.log(`Registering ${name}`);
    KeysToComponentMap[name] = component;
};
export const getGroupedComponents = () => {
    const groups = {
        design: {
            name: 'Design',
            components: [],
        },
        layouts: {
            name: 'Layout',
            components: [],
        },
        display: {
            name: 'Display',
            components: [],
        },
        landingPages: {
            name: 'Landing Pages',
            components: [],
        },
        deliveryPages: {
            name: 'Delivery Pages',
            components: [],
        },
        commerce: {
            name: 'Commerce / Membership',
            components: [],
        },
        account: {
            name: 'Account',
            components: [],
        },
        portal: {
            name: 'Portal',
            components: [],
        },
        hub: {
            name: 'Hub',
            components: [],
        },
        hidden: {
            name: 'Hidden',
            type: 'hidden',
            components: [],
        },
    };
    Object.values(KeysToComponentMap).reduce((g, c) => {
        if (c.meta && c.meta.group) {
            if (g[c.meta.group]) {
                g[c.meta.group].components.push(c);
            }
            else {
                console.log(`No group for ${c.meta.group}, skipping`);
            }
        }
        return groups;
    }, groups);
    Object.values(groups).forEach((g) => {
        g.components = sortBy(g.components, ['meta.sort', 'meta.name']);
    });
    return groups;
};
export default KeysToComponentMap;
//# sourceMappingURL=Registry.js.map